import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router';
import styles from './OutletAssociationModal.css';
import gobizLogoUrl from './gobiz-logo.png';
import mokaLogoUrl from './moka-logo.png';

class OutletAssociationModal extends Component {
  render() {
    const { onComplete, onCancel } = this.props;

    return (
      <Modal show>
        <Modal.Header>
          <Modal.Title>Your Outlets are Associated with GoBiz</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className={styles.logoRow}>
            <img src={mokaLogoUrl} alt="Moka Logo" />
            <img src={gobizLogoUrl} alt="GoBiz Logo" />
          </div>

          <p>
            Some of your outlets has been automatically associated with your
            GoBiz outlet, which means those outlets can be viewed in the GoBiz
            Dashboard as well. Kindly check the outlet association in the Outlet
            Page.
          </p>

          <p className={styles.footNote}>
            If you have any concern about this, please call our customer service
            at <b>1500970</b>
          </p>
        </Modal.Body>

        <Modal.Footer className={styles.footer}>
          <button type="button" className="btn btn-default" onClick={onCancel}>
            I'll Do It Later
          </button>
          <Link to="/outlets" className="btn btn-primary" onClick={onComplete}>
            Check Outlets
          </Link>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default OutletAssociationModal;
